import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Do you memento mori?",
  "description": "",
  "published": "2010-04-21T00:00:00.000Z",
  "redirect_from": ["/blog/do-you-memento-mori/swizec/1313"],
  "categories": "Carpe Diem, Carpe Noctem, Death, food for thought, life, Steve Jobs, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Today I read a nice post about the `}<a parentName="p" {...{
        "href": "http://laz.ly/Nc"
      }}>{`6 myths that stand in your way.`}</a>{` And there was one that stood out the most`}</p>
    <blockquote>
      <p parentName="blockquote"><strong parentName="p">{`Myth:`}</strong>{` There is time`}</p>
      <p parentName="blockquote"><strong parentName="p">{`Reality:`}</strong>{` You have less time now than you have ever had. You have less time now than you had an hour ago. You are nearer to your death than you have ever been. Plan thoroughly, but don’t wait too long before taking action.`}</p>
    </blockquote>
    <p>{`And then when you remember that `}<a parentName="p" {...{
        "href": "http://www.imdb.com/name/nm0423418/",
        "title": "Steve Jobs"
      }}>{`Steve Jobs`}</a>{` had a speech devoted almost completely to this notion of memento mori.`}</p>
    <p>{`Hell, the Romans came up with the whole memento mori crap far far ago ... I forget how the tradition went, but they used to punch winning generals in the face or something ... or was it that a slave was following them through the whole festivity whispering "memento mori" in their ear. Something like that.`}</p>
    <p>{`Then there's that tradition in greek weedings (judging from `}<a parentName="p" {...{
        "href": "http://anyclip.com/my-big-fat-greek-wedding",
        "title": "My Big Fat Greek Wedding"
      }}>{`Big Fat Greek Wedding`}</a>{`) where the bride is thrown off her chair - just to remind her she's mortal too.`}</p>
    <p>{`And way back when some smart poetry geek came up with the idea of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Carpe_diem",
        "title": "Carpe diem"
      }}>{`Carpe Diem`}</a>{` (later transformed to `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Carpe_Noctem_%28Angel_episode%29",
        "title": "Carpe Noctem (Angel episode)"
      }}>{`Carpe Noctem`}</a>{` and Carpe Pijem, the slovene version). Again basically the same concept!`}</p>
    <p>{`Then there's an interesting story I read on a forum once, it happened to a forumite's cousin or somesuch:`}</p>
    <blockquote>
      <p parentName="blockquote">{`She was a lass, around 23 years of age. Two lovely children, a loving husband, nice house and so on. One day they have a fight over something extremely mundane and boring. She gets pissed off and storms out of the house ... only to be mowed down by a truck.`}</p>
      <p parentName="blockquote">{`To death.`}</p>
    </blockquote>
    <p>{`So yeah, I know as `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Human",
        "title": "Human"
      }}>{`humans`}</a>{` we like to think we're something special, that each and everyone of us is a special little snowflake unique and wonderful in their own right.`}</p>
    <p>{`Well you're not. You too will die, today, tomorrow, in an hour, it doesn't matter.`}</p>
    <p>{`And nothing of value will be lost!`}</p>
    <p>{`Nothing!`}</p>
    <p>{`Nobody will care, absolutely nobody.`}</p>
    <p>{`I think people often forget these things and spend their whole lives doing boring shit they don't care about. Stop that!`}</p>
    <p>{`For the end, a quote from `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Anthony_de_Mello",
        "title": "Anthony de Mello"
      }}>{`Anthony de Mello`}</a>{`:`}</p>
    <blockquote>
      <p parentName="blockquote">{`Most people, even though they don’t know it, are asleep. They’re born asleep, they marry in their sleep, they breed children in their sleep, they die in their sleep without ever waking up`}</p>
    </blockquote>
    <p>{`But that just brings to mind this:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2010/04/sGMHosUzGq3f97umNNcaQBvXo1_500.png",
        "alt": null,
        "title": "xkcd subway scene"
      }}></img></p>
    <p>{`I dunno, just remember that whatever you do, all your life, you're on the verge of imminent death. Never forget.`}</p>
    <p><a parentName="p" {...{
        "href": "http://reblog.zemanta.com/zemified/41235a64-4632-4197-837a-31060887dedf/",
        "title": "Reblog this post [with Zemanta]"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/reblog_e.png?x-id=41235a64-4632-4197-837a-31060887dedf",
          "alt": "Reblog this post [with Zemanta]"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      